<a class="skip-link" href="#main-content">Skip to content</a>

<div class="shell" [class.shell--compact]="layout.isCompact()">
  <aside class="shell__nav">
    <navbar-component></navbar-component>
  </aside>

  <div class="shell__body">
    <header class="shell__top">
      <topbar-component></topbar-component>
    </header>
    <main id="main-content" class="shell__main">
      <router-outlet></router-outlet>
    </main>
  </div>

  <footer class="shell__player" aria-label="Player">
    <player-bar-component></player-bar-component>
  </footer>
</div>
